module.exports = __webpack_public_path__ + "static/media/Christmas.9a18054b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/Christmas.png
// module id = 1332
// module chunks = 3